import { Module, VuexModule, Mutation } from 'vuex-module-decorators'

import { ReportQuery } from '~/graphql/types'

@Module({
  name: 'report',
  stateFactory: true,
  namespaced: true,
})
export default class Report extends VuexModule {
  fetchStarted = false
  loading = true
  items: ReportQuery['report'] = []

  @Mutation
  setFetchStarted(fetchStarted) {
    this.fetchStarted = fetchStarted
  }

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this.items = items
  }
}
